// extracted by mini-css-extract-plugin
export var container = "_dg-0";
export var outlet = "_dg-1";
export var outletEnter = "_dg-2";
export var outletEnterActive = "_dg-3";
export var outletExit = "_dg-4";
export var outletExitActive = "_dg-5";